import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import flagBrazil from "../../imagens/flags/br.png";
import { faPhone, faEnvelope, faMapMarkerAlt, faClock } from "@fortawesome/free-solid-svg-icons";
// import flagEUA from "../../imagens/flags/us.png";
// import flagEU from "../../imagens/flags/EU.png";
import logoSsa from "../../imagens/logos/logoSSA.png";
import ReCAPTCHA from "react-google-recaptcha";
import "./pageTestContactUs.css";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";

const ContactUsComponent = () => {
  const { i18n, t } = useTranslation();
  const language = i18n.language;

  const [alertMessage, setAlertMessage] = useState(null);
  const [alertType, setAlertType] = useState(null);
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const navigate = useNavigate();

  const isValidDomain = async (email) => {
    const domain = email.split("@")[1];
    try {
      const response = await fetch(`https://dns.google/resolve?name=${domain}&type=MX`);
      const data = await response.json();
      return data.Answer && data.Answer.length > 0;
    } catch (error) {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);

    const formData = new FormData(e.target);
    const email = formData.get("email");

    if (!(await isValidDomain(email))) {
      setAlertMessage(
        language === "en"
          ? "Error: invalid email domain. Please check and try again."
          : "Erro: domínio de e-mail inválido. Verifique o endereço e tente novamente."
      );
      setAlertType("danger");
      setIsSending(false);
      return;
    }

    if (!recaptchaValue) {
      setAlertMessage(
        language === "en" ? "Please complete the reCAPTCHA." : "Por favor, complete o reCAPTCHA."
      );
      setAlertType("danger");
      setIsSending(false);
      return;
    }

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID_CONTACT_US,
        e.target,
        process.env.REACT_APP_PUBLI
      )
      .then(
        () => {
          setAlertMessage(language === "en" ? "Email sent successfully!" : "Email enviado com sucesso!");
          setAlertType("success");
          e.target.reset();
          setIsSending(false);
          setTimeout(() => navigate("/ContactUs"), 1000);
        },
        (error) => {
          console.error("Erro ao enviar e-mail:", error);
          setAlertMessage(
            language === "en" ? "Error sending email. Please try again." : "Erro ao enviar e-mail. Tente novamente."
          );
          setAlertType("danger");
          setIsSending(false);
        }
      );
  };

  const handleRecaptchaChange = (value) => setRecaptchaValue(value);

  return (
    <div>
      <section className="container w-100">
        <div className="row">
          <h2 className="bgColorCustom text-center my-4">{t("contactUs.title")}</h2>

          {/* =======================================================
              CARD LATERAL (ADAPTADO PARA SSA)
             ======================================================= */}
          <div className="col-lg-6 col-md-12 mb-4 p-0 d-flex justify-content-center align-items-center">
            <div className="contact-card w-75 p-4 pt-4 align-items-center justify-content-center">

              {/* Cabeçalho do Card: Bandeira + Nome SSA */}
              <div className="d-flex align-items-center mb-5 pb-2">

                <h4 className="m-0 mb-3 fw-bold text-custom">
                  <img
                    src={logoSsa}
                    alt="Bandeira do Brasil"
                    className="me-2 rounded "
                    style={{ width: "100px", height: "auto", objectFit: "contain" }}
                  />
                  <img
                    src={flagBrazil}
                    alt="Bandeira do Brasil"
                    className="me-2 rounded "
                    style={{ width: "50px", height: "auto", objectFit: "contain" }}
                  />
                  <br />
                  <span className="text-custom" style={{ fontSize: '0.9em' }}>{t("contactUs.companyName")}</span>

                </h4>
              </div>

              {/* Texto de intro */}
              <p className="text-custom fw-bold">{t("contactUs.contactText")}</p>

              {/* Lista de Informações */}
              <ul className="list-unstyled text-dark">

                {/* Endereço */}
                <li className="mb-3 d-flex">
                  <span>
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-red mt-1" />
                    <strong>{t("contactUs.address")}:</strong><br />
                    Av. Das Indústrias, 1001 - Ouro Fino, MG<br />
                    CEP: 37570-000
                  </span>
                </li>

                {/* Telefone */}
                <li className="mb-3">
                  <FontAwesomeIcon icon={faPhone} className="me-2 text-red" />
                  {/* Se quiser usar o número dos EUA do código antigo: +1 2482375398 */}
                  <strong>{t("contactUs.phone")}:</strong> (35) 3441-0000
                </li>

                {/* Email (Se tiver um email geral, coloque aqui) */}
                <li className="mb-3">
                  <FontAwesomeIcon icon={faEnvelope} className="me-2 text-red" />
                  <strong>{t("contactUs.email")}:</strong> contato@ssa-automotiva.com.br
                </li>

                {/* Horário (Puxando da tradução) */}
                <li className="mb-3">
                  <FontAwesomeIcon icon={faClock} className="me-2 text-red" />
                  <strong>{t("contactUs.hours")}:</strong> {t("contactUs.workingHours")}
                </li>

              </ul>

              {/* Botão do Mapa (Link da SSA) */}
              <a
                href="https://www.google.com/maps/place/SSA+-+Solu%C3%A7%C3%B5es+em+Sistemas+Automotivos+LTDA/@-22.2716885,-46.3700352,17z/data=!3m1!4b1!4m6!3m5!1s0x94cc4dcff76da3e5:0x8e68c9f9abed01b0!8m2!3d-22.2716885!4d-46.3700352!16s%2Fg%2F1ptw_6vcs?entry=ttu&g_ep=EgoyMDI2MDEyNS4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-contactUsCard w-auto align-self-center mt-3"
              >
                {t("contactUs.viewOnMaps")}
              </a>
            </div>
          </div>
          {/* Formulário */}
          <div className="col-lg-6 col-md-12">


            <form onSubmit={handleSubmit}>
              <h2 className="text-center bgColorCustom">
                {language === "en" ? "Send a Message" : "Envie uma mensagem"}
              </h2>

              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  {language === "en" ? "Name:" : "Nome:"}
                </label>
                <input type="text" id="name" name="name" className="form-control" required />
              </div>

              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  {language === "en" ? "Email:" : "Email:"}
                </label>
                <input type="email" id="email" name="email" className="form-control" required />
              </div>

              <div className="mb-3">
                <label htmlFor="Number" className="form-label">
                  {language === "en" ? "Number:" : "Número:"}
                </label>
                <input id="Number" name="Number" className="form-control" required />
              </div>

              <div className="mb-3">
                <label htmlFor="subject" className="form-label">
                  {language === "en" ? "Subject:" : "Assunto:"}
                </label>
                <input id="subject" name="subject" className="form-control" required />
              </div>

              <div className="mb-3">
                <label htmlFor="message" className="form-label">
                  {language === "en" ? "Write your message:" : "Escreva sua mensagem:"}
                </label>
                <textarea id="message" name="message" className="form-control" rows="5" required></textarea>
              </div>

              <div className="mb-3">
                <ReCAPTCHA
                  sitekey="6LfltZkqAAAAAMl7b8dSoSs0zqfmtW07rtqST7cb"
                  onChange={handleRecaptchaChange}
                />
              </div>

              <button type="submit" className="btn btn-success mb-3" disabled={isSending}>
                {isSending ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                ) : (
                  language === "en" ? "Send Message" : "Enviar mensagem"
                )}
              </button>

              {isSending && (
                <p className="text-info">
                  {language === "en" ? "Sending message, please wait..." : "Enviando mensagem, por favor aguarde..."}
                </p>
              )}
              {alertMessage && (
                <div className={`alert alert-${alertType} mt-3`} role="alert">
                  {alertMessage}
                </div>
              )}
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUsComponent;
